// import { appIcon } from '@/const/underwriting'
/*
 * This file is used for breadcrumb generation (with proper hierarchy) and title lookup. Also used for Menu searching.
 *
 * name: must be unique, lower-case, no-space (primary-key and must be same as route name) - try not to change it for no reason
 * text: Display on screen
 * icon: Custom icon for menu
 * desc: Description of application
 * children: hierarchy of menu
 * hidden: true if it should be hidden from menu display (also not searchable - used for breadcrumb auto generation)
 * searchable: used only if hidden is true (to allow search even if it is hidden)
 * route: true if menu should route to a page
 * access: access control. Look at router/index.js
 */
export const Menu = [
  {
    name: 'dashboard',
    text: 'Dashboard',
    route: true,
    children: [
      {
        name: 'coreSys',
        text: 'Core System',
        children: [
          {
            name: 'policyAdmin',
            text: 'Policy Administration',
            icon: 'mdi-gavel',
            children: [
              {
                name: 'policyListing',
                text: 'Manage Policies',
                icon: 'mdi-apps',
                route: true,
                children: [
                  { name: 'policyGeneral', text: 'Policy General', hidden: true, route: true },
                  { name: 'policyHeader', text: 'Policy Header', hidden: true, route: true },
                  { name: 'policyInsured', text: 'Policy Header', hidden: true, route: true },
                  { name: 'policyOtherDetails', text: 'Policy Header', hidden: true, route: true },
                  { name: 'policyRenewalInfo', text: 'Policy Renewal Information', hidden: true, route: true },
                  { name: 'policyAmend', text: 'Amend Policy', hidden: true, route: true },
                  {
                    name: 'policyRisk',
                    text: 'Policy Risk',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'policyRiskDetails', text: 'Risk Details', hidden: true, route: true },
                      { name: 'policyCoverage', text: 'Risk Coverage', hidden: true, route: true },
                      { name: 'policyRiskTrailer', text: 'Risk Trailer', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'policySummary',
                    text: 'Policy Summary',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'policyInstalments', text: 'Instalments', hidden: true, route: true },
                      { name: 'policyAmendRetention', text: 'Amend Retention', hidden: true, route: true },
                      { name: 'policyCoinsServiceFee', text: 'Coinsurance Service Fee', hidden: true, route: true }
                    ]
                  },
                  { name: 'policyReinsurance', text: 'Reinsurance', hidden: true, route: true },
                  { name: 'policyGeneral', text: 'Policy General', hidden: true, route: true },
                  { name: 'queryPolicy',
                    text: 'Policy',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'queryPolicyGroup', text: 'Policy Details', hidden: true, route: true },
                      { name: 'queryPolicyRisk', text: 'Policy Risk', hidden: true, route: true },
                      { name: 'queryPolicyCoverage', text: 'Policy Coverage', hidden: true, route: true },
                      { name: 'queryPolicySummary', text: 'Policy Summary', hidden: true, route: true },
                      { name: 'queryPolicyInstalments', text: 'Policy Instalments', hidden: true, route: true },
                      { name: 'queryPolicyAmendRetention', text: 'Amend Retention', hidden: true, route: true },
                      { name: 'queryPolicyRiskTrailer', text: 'Risk Trailer', hidden: true, route: true },
                      { name: 'queryPolicyRiHeader', text: 'Ri Header', hidden: true, route: true },
                      { name: 'queryPolicyRiDetail', text: 'Ri Details', hidden: true, route: true }
                    ]
                  },
                  { name: 'deleteUnreleasedPolicy', text: 'Delete Unreleased Policy', hidden: true, route: true }
                ]
              },
              {
                name: 'propListing',
                text: 'UOB Proposals',
                icon: 'mdi-apps',
                route: true,
                children: [
                  { name: 'queryProposal', text: 'Proposal', hidden: true, route: true },
                  { name: 'reviewProposal', text: 'Proposal', hidden: true, route: true },
                  { name: 'convertProposal', text: 'Convert Proposal to Policy', hidden: true, route: true }
                ]
              },
              {
                name: 'riOutwardList',
                text: 'Process Reinsurance',
                icon: 'mdi-apps',
                route: true,
                children: [
                  { name: 'riHeader', text: 'RI Outwards', hidden: true, route: true },
                  { name: 'riOutAmend', text: 'Amend RI Outwards', hidden: true, route: true }
                ]
              },
              {
                name: 'specialFuncUW',
                text: 'Special Functions',
                children: [
                  { name: 'batchPolicyRelease', text: 'Batch Policy Release', icon: 'mdi-apps', route: true },
                  { name: 'batchRiOutwardsRelease', text: 'Batch RI Outwards Release', icon: 'mdi-apps', route: true },
                  { name: 'normTreatySurplus', text: 'Block Normalisation', icon: 'mdi-apps', route: true },
                  { name: 'deleteUnreleasedRenewals', text: 'Delete Unreleased Renewals', icon: 'mdi-apps', route: true },
                  { name: 'ncdDetails', text: 'NCD Details (GEARS)', icon: 'mdi-apps', route: true },
                  { name: 'facRIBord', text: 'Post RI Fac Bordereaux', icon: 'mdi-apps', route: true },
                  { name: 'processRenewals', text: 'Process Renewals', icon: 'mdi-apps', route: true },
                  { name: 'riskAccumulation', text: 'Risk Accumulation', icon: 'mdi-apps', route: true },
                  { name: 'riskAccumulationQuery', text: 'Risk Accumulation Query', icon: 'mdi-apps', route: true },
                  { name: 'riskSurveyListing',
                    text: 'Risk Survey',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'riskSurvey', text: 'Risk Survey', hidden: true, route: true },
                      { name: 'riskSurveyHeader', text: 'Risk Survey Header', hidden: true, route: true },
                      { name: 'riskSurveyConstn', text: 'Risk Survey Construction', hidden: true, route: true },
                      { name: 'riskSurveySurr', text: 'Risk Survey Surroundings', hidden: true, route: true },
                      { name: 'riskSurveyLight', text: 'Risk Survey Lighting', hidden: true, route: true },
                      { name: 'riskSurveyFirePrev', text: 'Risk Survey Fire Prevention', hidden: true, route: true },
                      { name: 'riskSurveyMgmt', text: 'Risk Survey Management', hidden: true, route: true },
                      { name: 'riskSurveyInsInsd', text: 'Risk Survey Interest Insured', hidden: true, route: true },
                      { name: 'riskSurveyOccp', text: 'Risk Survey Occupation', hidden: true, route: true },
                      { name: 'riskSurveyFireAttch', text: 'Risk Survey Fire Attachment', hidden: true, route: true },
                      { name: 'riskSurveyStockDesc', text: 'Risk Survey Stock Description', hidden: true, route: true },
                      { name: 'riskSurveyPremDesc', text: 'Risk Survey Premises Description', hidden: true, route: true },
                      { name: 'riskSurveyEnt', text: 'Risk Survey Entrance', hidden: true, route: true },
                      { name: 'riskSurveySafe', text: 'Risk Survey Safe Room', hidden: true, route: true },
                      { name: 'riskSurveyBurg', text: 'Risk Survey Burglary Attachment', hidden: true, route: true }
                    ] },
                  // { name: 'trtyCssnNormalisation', text: 'Treaty Cession Normalisation', icon: 'mdi-apps', route: true },
                  { name: 'undoPolicyListing',
                    text: 'Undo Policy Release',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'undoPolicyRelease', text: 'Undo Policy Release', hidden: true, route: true }
                    ]
                  },
                  { name: 'downloadUOBProposal', text: 'UOB Proposal Download', icon: 'mdi-apps', route: true },
                  { name: 'uploadUOBProposal', text: 'UOB Proposal Upload', icon: 'mdi-apps', route: true }
                ]
              },
              {
                name: 'interface',
                text: 'Interface',
                children: [
                  { name: 'motorTransactionsGIA', text: 'GIA - Motor Transactions', icon: 'mdi-apps', route: true },
                  { name: 'dlTravelClmGIA', text: 'GIA - Travel Claims', icon: 'mdi-apps', route: true },
                  { name: 'wicTransactionsGIA', text: 'GIA - WIC Transactions', icon: 'mdi-apps', route: true },
                  { name: 'motorPoliciesLTA', text: 'LTA - Motor Policies', icon: 'mdi-apps', route: true },
                  { name: 'purgeVehDetReq', text: 'LTA - Purge Vehicle Details Request', icon: 'mdi-apps', route: true },
                  {
                    name: 'vehDetReq',
                    text: 'LTA - Query Vehicle Details Request',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'queryVehDetReq', text: 'Vehicle Details Request', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'vehChas',
                    text: 'LTA - Query Vehicle Registration & Chassis Change',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'queryVehChas', text: 'Vehicle Registration & Chassis Change', hidden: true, route: true }
                    ]
                  },
                  { name: 'unsetLTATranDate', text: 'LTA - Unset Transmission Date', icon: 'mdi-apps', route: true },
                  { name: 'detReqAppendixCF', text: 'LTA - Upload Vehicle Details Request (C/F)', icon: 'mdi-apps', route: true },
                  { name: 'uploadChangeLtaVegNo', text: 'LTA Vehicle Registration & Chassis Change File', icon: 'mdi-apps', route: true },
                  { name: 'masAML', text: 'MAS - AML Report', icon: 'mdi-apps', route: true },
                  {
                    name: 'sanctionList',
                    text: 'MAS - Sanction List',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'querySanction', text: 'Sanction List', hidden: true, route: true }
                    ]
                  },
                  { name: 'uploadMASSanctionList', text: 'MAS - Upload Sanction List', icon: 'mdi-apps', route: true },
                  { name: 'uploadPostalCode', text: 'Upload Postal Code', icon: 'mdi-apps', route: true },
                  { name: 'bonPolMOM', text: 'MOM - Bond Policies', icon: 'mdi-apps', route: true },
                  { name: 'unsetBondPolMOM', text: 'MOM - Unset Bond Policies Date for Re-submission', icon: 'mdi-apps', route: true },
                  { name: 'wicPolMOM', text: 'MOM - WIC Policies', icon: 'mdi-apps', route: true },
                  { name: 'wicPolMOMAudit', text: 'MOM Audit - WIC Policies', icon: 'mdi-apps', route: true },
                  { name: 'resendToLTA', text: 'Resend to LTA', icon: 'mdi-apps', route: true },
                  { name: 'recLtaDF3', text: 'Lta Data File 3', icon: 'mdi-apps', route: true }
                ]
              },
              {
                name: 'documentUW',
                text: 'Documents',
                children: [
                  { name: 'uwdrcr', text: 'Policy Documentation', icon: 'mdi-file-document', route: true },
                  // { name: 'cargoSchedule', text: 'Policy Schedule - Cargo', icon: 'mdi-file-document', route: true },
                  // { name: 'fireSchedule', text: 'Policy Schedule - Fire', icon: 'mdi-file-document', route: true },
                  // { name: 'marineSchedule', text: 'Policy Schedule - Marine', icon: 'mdi-file-document', route: true },
                  // { name: 'uwHullSched', text: 'Policy Schedule - Hull', icon: 'mdi-file-document', route: true },
                  // { name: 'UWMiscSched', text: 'Policy Schedule - Miscellaneous', icon: 'mdi-file-document', route: true },
                  // { name: 'motorSchedule', text: 'Policy Schedule - Motor', icon: 'mdi-file-document', route: true },
                  { name: 'lossCIDeclaration', text: 'Loss of CI Declaration', icon: 'mdi-file-document', route: true }
                ]
              }
            ]
          },
          {
            name: 'claimManagement',
            text: 'Claims Management',
            icon: 'mdi-cash',
            children: [
              {
                name: 'mngClaim',
                text: 'Manage Claims',
                icon: 'mdi-apps',
                route: true,
                children: [
                  { name: 'claimRegister', text: 'Claim', hidden: true, route: true },
                  { name: 'claimHeader', text: 'Claim Header', hidden: true, route: true },
                  { name: 'claimClaimant', text: 'Claimant', hidden: true, route: true },
                  { name: 'claimItem', text: 'Claim Item', hidden: true, route: true },
                  { name: 'claimReserve', text: 'Claim Reserve', hidden: true, route: true },
                  { name: 'claimPaymentList', text: 'Claim Payment', hidden: true, route: true },
                  { name: 'claimPayment', text: 'Claim Payment', hidden: true, route: true },
                  { name: 'qClaimPayment', text: 'Payment Details', hidden: true, route: true },
                  { name: 'claimReopenHeader', text: 'Claim Details', hidden: true, route: true },
                  {
                    name: 'qClaimHeader',
                    text: 'Claim Header',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'queryClmPay', text: 'Payment Details', hidden: true, route: true },
                      { name: 'queryInsured', text: 'Insured', hidden: true, route: true },
                      { name: 'queryClmRIHdr', text: 'Reinsurance Details', hidden: true, route: true }
                    ]
                  },
                  { name: 'qClaimClaimant', text: 'Claimant', hidden: true, route: true },
                  { name: 'qClaimItem', text: 'Claim Item', hidden: true, route: true }
                ]
              },
              {
                name: 'clmRenMsg',
                text: 'Renewal Messages',
                icon: 'mdi-apps',
                route: true,
                children: [
                  { name: 'reviewRenMsg', text: 'Review Renewal Messages', hidden: true, route: true }
                ]
              },
              {
                name: 'specialFuncClm',
                text: 'Special Functions',
                children: [
                  { name: 'inProgress(04)', text: 'Claims Reserve Revaluation', route: true },
                  {
                    name: 'clmUnrelDel',
                    text: 'Delete Unreleased Claims Transaction',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'clmUnrelDelPayDet', text: 'Delete Unreleased Claims Payment Details', hidden: true, route: true }
                    ]
                  },
                  { name: 'processXOLRecovery', text: 'Generate XOL Recoveries', icon: 'mdi-apps', route: true },
                  {
                    name: 'osClmRes',
                    text: 'Post Outstanding Claims Reserve',
                    icon: 'mdi-apps',
                    route: true
                  },
                  { name: 'processClmRIRcvy', text: 'Process Claims RI Recoveries', icon: 'mdi-apps', route: true },
                  {
                    name: 'clmRel',
                    text: 'Release Claims Transaction',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'clmRelPayDet', text: 'Release Claims Payment Details', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'unsetClmDocPrtFlag',
                    text: 'Unset Claims Document Print Flag',
                    icon: 'mdi-apps',
                    route: true
                  },
                  {
                    name: 'xolList',
                    text: 'XOL Worksheet',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'xolRecovery', text: 'XOL Worksheet', hidden: true, route: true }
                    ]
                  }
                ]
              },
              {
                name: 'documentClm',
                text: 'Documents',
                children: [
                  { name: 'clmCreditNote', text: 'Claims Credit Note', icon: 'mdi-file-document', route: true },
                  { name: 'clmDebitNote', text: 'Claims Debit Note', icon: 'mdi-file-document', route: true },
                  { name: 'clmPaytVou', text: 'Claims Payment Voucher', icon: 'mdi-file-document', route: true },
                  { name: 'clmReceipt', text: 'Claims Receipt', icon: 'mdi-file-document', route: true },
                  { name: 'clmFaceSht', text: 'Claims Face Sheet', icon: 'mdi-file-document', route: true },
                  {
                    name: 'clmRIAdvice',
                    text: 'Claims RI Advice',
                    icon: 'mdi-file-document',
                    route: true,
                    children: [
                      { name: 'clmRIAdviceReprint', text: 'Reprint Claims RI Advice', hidden: true, route: true }
                    ]
                  },
                  { name: 'clmRiRcvyR', text: 'Reprint RI Recoveries', icon: 'mdi-file-document', route: true }
                ]
              }
            ]
          },
          {
            name: 'accounting',
            text: 'Accounting',
            icon: 'mdi-calculator',
            children: [
              // SSY: Manage Account Layout changes
              // {
              //   name: 'mngAcct',
              //   text: 'Manage Accounts',
              //   route: true
              // },
              {
                name: 'accounts',
                text: 'Manage Accounts',
                icon: 'mdi-apps',
                route: true,
                children: [
                  { name: 'accountsDetails', text: 'Accounts Transactions', hidden: true, route: true }
                ]
              },
              {
                name: 'receipts',
                text: 'Receipt',
                route: true,
                icon: 'mdi-receipt',
                children: [
                  { name: 'createReceipt', text: 'Receipt', hidden: true, route: true },
                  { name: 'reviewReceipt', text: 'Receipt', hidden: true, route: true },
                  { name: 'queryReceipt', text: 'Receipt', hidden: true, route: true },
                  { name: 'mulAcctReceipt',
                    text: 'Multiple Accounts for Receipt',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'createMulAcctReceipt', text: 'Receipt', hidden: true, route: true },
                      { name: 'queryMulAcctReceipt', text: 'Receipt', hidden: true, route: true }
                    ]
                  }
                ]
              },
              {
                name: 'payment',
                text: 'Payment',
                route: true,
                icon: 'mdi-cash',
                children: [
                  { name: 'createPayment', text: 'Payment', hidden: true, route: true },
                  { name: 'queryPayment', text: 'Payment', hidden: true, route: true },
                  { name: 'mulAcctPayment',
                    text: 'Multiple Accounts for Payment',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'createMulAcctPayment', text: 'Payment', hidden: true, route: true },
                      { name: 'queryMulAcctPayment', text: 'Payment', hidden: true, route: true }
                    ]
                  }
                ]
              },
              {
                name: 'creditNote',
                text: 'Credit Note',
                route: true,
                icon: 'mdi-credit-card',
                children: [
                  {
                    name: 'createCreditNote',
                    text: 'Credit Note',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'glCreditNote', text: 'GL Transactions', hidden: true, route: true }
                    ]
                  },
                  { name: 'queryCreditNote', text: 'Credit Note', hidden: true, route: true }
                ]
              },
              {
                name: 'debitNote',
                text: 'Debit Note',
                route: true,
                icon: 'mdi-credit-card-multiple',
                children: [
                  {
                    name: 'createDebitNote',
                    text: 'Debit Note',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'glDebitNote', text: 'GL Transactions', hidden: true, route: true }
                    ]
                  },
                  { name: 'queryDebitNote', text: 'Debit Note', hidden: true, route: true }
                ]
              },
              { name: 'nonTrade',
                text: 'Non-Trade',
                route: true,
                icon: 'mdi-credit-card-multiple',
                children: [
                  { name: 'createNonTrade',
                    text: 'Non-Trade',
                    hidden: true,
                    route: true,
                    children: [
                      { name: 'glNonTrade', text: 'GL Transactions', hidden: true, route: true }
                    ]
                  }
                ]
              },
              {
                name: 'matching',
                text: 'Matching',
                children: [
                  { name: 'batchMatch', text: 'Batch Match Transactions', icon: 'mdi-apps', hidden: true, route: true },
                  {
                    name: 'matchTransaction',
                    text: 'Match Transactions',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'reviewMatchTransaction', text: 'Matched Transactions', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'matchTransactionUpload',
                    text: 'Batch Match Transactions Upload',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'reviewMatchTransactionUpload', text: 'Matched Transactions Upload', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'undoMatched',
                    text: 'Undo Matched Transactions',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'reviewUndoMatched', text: 'Undo Matched Transactions', hidden: true, route: true }
                    ]
                  }
                ]
              },
              {
                name: 'specFuncAcct',
                text: 'Special Functions',
                children: [
                  { name: 'dlGLTran', text: 'Download GL Transactions (SUNGL)', icon: 'mdi-apps', route: true },
                  { name: 'exclGsttran', text: 'Exclude GST Patching', icon: 'mdi-apps', route: true },
                  { name: 'gstRebilling', text: 'GST Re-billing', icon: 'mdi-apps', route: true },
                  { name: 'postExchangeDifferences', text: 'Post Exchange Differences', icon: 'mdi-apps', route: true },
                  // { name: 'manageComVoucher', text: 'Process Commission Vouchers', icon: 'mdi-apps', route: true },
                  { name: 'voidAccountTransaction', text: 'Void Accounts Transaction', icon: 'mdi-apps', route: true },
                  { name: 'writeOffSmallBal', text: 'Write-Off Small Balances', icon: 'mdi-apps', route: true },
                  { name: 'ifrsDataExtraction', text: 'IFRS Data Extraction', icon: 'mdi-apps', route: true }
                ]
              },
              {
                name: 'generalLedger',
                text: 'General Ledger',
                children: [
                  { name: 'glTran', text: 'Amend GL Transaction', icon: 'mdi-apps', route: true },
                  { name: 'batchGlUpd', text: 'Batch GL Update', icon: 'mdi-apps', route: true },
                  { name: 'closeFinYear', text: 'Close Financial Year', icon: 'mdi-apps', route: true },
                  { name: 'inProgress(13)', text: 'Foreign Exchange Revaluation', route: true },
                  { name: 'journalTransaction',
                    text: 'Journal',
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'journalDetails', text: 'Journal', hidden: true, route: true }
                    ]
                  },
                  { name: 'inProgress(14)', text: 'Reinstate Closed Financial Year', route: true },
                  { name: 'startFinYear', text: 'Start New Financial Year', icon: 'mdi-apps', route: true },
                  { name: 'uprAnnualAndGL', text: 'Unearned Premium Reserves', icon: 'mdi-apps', route: true }
                ]
              },
              {
                name: 'documentAcct',
                text: 'Documents',
                children: [
                  { name: 'acctDocBchReprt', text: 'Accounts Documentation', icon: 'mdi-file-document', route: true },
                  // { name: 'inProgress(16)', text: 'Commission Voucher', route: true },
                  { name: 'stmtAcct', text: 'Statement of Account', icon: 'mdi-file-document', route: true }
                ]
              }
            ]
          },
          {
            name: 'clientMgmt',
            text: 'Client Management',
            icon: 'mdi-account-multiple-plus',
            children: [
              {
                name: 'insureds',
                text: 'Manage Insured',
                icon: 'mdi-account-group',
                route: true,
                children: [
                  { name: 'queryDetails', text: 'Insured', hidden: true, route: true },
                  { name: 'queryCurrPortfolioMenu', text: 'Current Portfolio', hidden: true, route: true },
                  { name: 'reviewDetails', text: 'Insured', hidden: true, route: true },
                  { name: 'currPortfolioMenu', text: 'Current Portfolio', hidden: true, route: true },
                  { name: 'clientType', text: 'Client Type', route: true }
                ]
              },
              {
                name: 'intermediaries',
                text: 'Manage Intermediary',
                icon: 'mdi-account-group',
                route: true,
                children: [
                  { name: 'commissionMenu', text: 'Commission', hidden: true, route: true },
                  { name: 'interCurrPortfolioMenu', text: 'Current Portfolio', hidden: true, route: true },
                  { name: 'queryProfile', text: 'Profile', hidden: true, route: true },
                  { name: 'queryCommissionMenu', text: 'Commission', hidden: true, route: true },
                  { name: 'queryInterCurrPortfolioMenu', text: 'Current Portfolio', hidden: true, route: true },
                  { name: 'reviewProfile', text: 'Profile', hidden: true, route: true },
                  { name: 'execInCharge', text: 'Executive In Charge', route: true },
                  { name: 'interScheme',
                    text: 'Permitted Scheme per Intermediary',
                    hidden: true,
                    icon: 'mdi-apps',
                    route: true,
                    children: [
                      { name: 'interSchemeDetail', text: 'Permitted Scheme per Intermediary', hidden: true, route: true }
                    ]
                  },
                  { name: 'interType', text: 'Intermediary Type', route: true }
                ]
              },
              { name: 'customerLogHistoryReport', text: 'Customer Log History', icon: 'mdi-file-chart', route: true },
              { name: 'customerLogStatisticsReport', text: 'Customer Log Statistics', icon: 'mdi-file-chart', route: true }
            ]
          },
          {
            name: 'report',
            text: 'Reports',
            icon: 'mdi-file-chart',
            children: [
              {
                name: 'reportUW',
                text: 'Underwriting Reports',
                children: [
                  { name: 'autoBatchRenewal', text: 'Auto Batch Renewal', icon: 'mdi-file-chart', route: true },
                  { name: 'autoBatchRenewalHDB', text: 'Auto Batch Renewal HDB', icon: 'mdi-file-chart', route: true },
                  { name: 'autoBatchRenewalUPP', text: 'Auto Batch Renewal UPP', icon: 'mdi-file-chart', route: true },
                  { name: 'autoBatchRenewalUPPListing', text: 'Auto Batch Renewal UPP Listing', icon: 'mdi-file-chart', route: true },
                  { name: 'autoRenCvrLet', text: 'Auto Renewal Covering Letter', icon: 'mdi-file-chart', route: true },
                  { name: 'blkParamChk', text: 'Block Parameters Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'coinsPrem', text: 'Coinsurance Premiums', icon: 'mdi-file-chart', route: true },
                  { name: 'consPrem', text: 'Consolidated Premiums', icon: 'mdi-file-chart', route: true },
                  { name: 'expPolRPRpt', text: 'Expiring Policies RI Panel', icon: 'mdi-file-chart', route: true },
                  { name: 'expPolWitFinInsRpt', text: 'Expiring Policies with Financial Institution', icon: 'mdi-file-chart', route: true },
                  { name: 'fireFreeInsExpRpt', text: 'Fire Free Insurance Expiring', icon: 'mdi-file-chart', route: true },
                  { name: 'inBusAnalysisGross', text: 'Inwards Business Analysis - Gross', icon: 'mdi-file-chart', route: true },
                  { name: 'IPR', text: 'Inwards Premium Register', icon: 'mdi-file-chart', route: true },
                  { name: 'marineList', text: 'Marine List by Account No.', icon: 'mdi-file-chart', route: true },
                  { name: 'monthlySurplusTreaty', text: 'Monthly Surplus Treaty', icon: 'mdi-file-chart', route: true },
                  { name: 'renPolUnrel', text: 'Policies Not Released', icon: 'mdi-file-chart', route: true },
                  { name: 'polChkList', text: 'Policy Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'premClmSumm', text: 'Premium & Claims Summary', icon: 'mdi-file-chart', route: true },
                  { name: 'premAnalysis1', text: 'Premium Analysis 1', icon: 'mdi-file-chart', route: true },
                  { name: 'premAnalysis2', text: 'Premium Analysis 2', icon: 'mdi-file-chart', route: true },
                  { name: 'premIncome', text: 'Premium Income for Properties Mortgaged', icon: 'mdi-file-chart', route: true },
                  { name: 'premSum', text: 'Premium Summary', icon: 'mdi-file-chart', route: true },
                  { name: 'prodMenu', text: 'Productivity Statistics', icon: 'mdi-file-chart', route: true },
                  { name: 'CltProfStat', text: 'Profitability Statistics', icon: 'mdi-file-chart', route: true },
                  { name: 'rdptnRpt', text: 'Redemptions', icon: 'mdi-file-chart', route: true },
                  { name: 'renewals', text: 'Renewals', icon: 'mdi-file-chart', route: true },
                  { name: 'riskBlkSIChkList', text: 'Risk Block SI Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'riskProf', text: 'Risk Profiles', icon: 'mdi-file-chart', route: true },
                  { name: 'riskSurveyRpt', text: 'Risk Surveys', icon: 'mdi-file-chart', route: true },
                  { name: 'sdsRcptPayt', text: 'SDS Receipt/Payment Transactions', icon: 'mdi-file-chart', route: true },
                  { name: 'statsByBusGrp', text: 'Statistics by Business Group', icon: 'mdi-file-chart', route: true },
                  { name: 'spTtyMasterlist', text: 'Surplus Treaty Masterlist', icon: 'mdi-file-chart', route: true },
                  { name: 'ttyLimChkList', text: 'Treaty Limit Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'busAnalysis', text: 'Type of Business Analysis', icon: 'mdi-file-chart', route: true },
                  { name: 'propChkList', text: 'UOB Proposal Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'printLTA', text: 'Print LTA Request/Response', icon: 'mdi-file-chart', route: true },
                  { name: 'PolDueExp', text: 'Policies Due To Expire', icon: 'mdi-file-chart', route: true },
                  { name: 'RenewalListing', text: 'Renewal Listing', icon: 'mdi-file-chart', route: true },
                  { name: 'BoIncScheme', text: 'Bonus Incentive Scheme', icon: 'mdi-file-chart', route: true },
                  { name: 'proByACYear', text: 'Profitability by A/C Year', icon: 'mdi-file-chart', route: true },
                  { name: 'LadderStats', text: 'Ladder Statistics', icon: 'mdi-file-chart', route: true }
                ]
              },
              {
                name: 'reportRI',
                text: 'Reinsurance Reports',
                children: [
                  { name: 'contrtCert', text: 'Contract Certainty', icon: 'mdi-file-chart', route: true },
                  { name: 'facRIBord', text: 'Facultative Reinsurance Bordereaux', icon: 'mdi-file-chart', route: true },
                  { name: 'gnpiAndXolPremiums', text: 'GNPI & XOL Premiums', icon: 'mdi-file-chart', route: true },
                  { name: 'outPremComm', text: 'Outwards Premiums & Commissions', icon: 'mdi-file-chart', route: true },
                  { name: 'outPremReg', text: 'Outwards Premium Register', icon: 'mdi-file-chart', route: true },
                  { name: 'riAppBordereaux', text: 'RI Application Bordereaux', icon: 'mdi-file-chart', route: true },
                  { name: 'riGrossPremStats', text: 'RI Gross Premium Statistics', icon: 'mdi-file-chart', route: true },
                  { name: 'riOutChecklist', text: 'RI Outwards Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'spTtyTrans', text: 'Surplus Treaty Transactions', icon: 'mdi-file-chart', route: true },
                  { name: 'polPendingRI', text: 'Policies Pending Reinsurance', icon: 'mdi-file-chart', route: true },
                  { name: 'ttyOutTranChklst', text: 'Treaty Outwards Trans Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'premAnalysis2RI', text: 'Premium Analysis 2', icon: 'mdi-file-chart', route: true }
                ]
              },
              {
                name: 'reportClm',
                text: 'Claims Reports',
                children: [
                  { name: 'claimGrossRes', text: 'Claims Gross Reserves', icon: 'mdi-file-chart', route: true },
                  { name: 'claimGrossResUW', text: 'Claims Gross Reserve 2 (for Underwriting)', icon: 'mdi-file-chart', route: true },
                  { name: 'claimsMovement', text: 'Claims Movement', icon: 'mdi-file-chart', route: true },
                  { name: 'claimsPaidAndLossRes', text: 'Claims Paid & Loss Reserves', icon: 'mdi-file-chart', route: true },
                  { name: 'claimPaymentReport', text: 'Claims Payments', icon: 'mdi-file-chart', route: true },
                  { name: 'claimRegisterReport', text: 'Claims Register', icon: 'mdi-file-chart', route: true },
                  { name: 'clmRIAdjChklistReport', text: 'Claims RI Adjustment Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'claimsRIBordereaux', text: 'Claims RI Bordereaux', icon: 'mdi-file-chart', route: true },
                  { name: 'claimwoReserves', text: 'New Claims Checklist w/o Reserves', icon: 'mdi-file-chart', route: true },
                  // { name: 'riClaimsSummary', text: 'RI Claims Summary', icon: 'mdi-file-chart', route: true },
                  { name: 'riOutClmSum', text: 'RI Outwards Claims Summary', icon: 'mdi-file-chart', route: true },
                  { name: 'claimByNextLastReviewDate', text: 'Claim By Next/Last Review Date', icon: 'mdi-file-chart', route: true },
                  { name: 'clmListByAgentOrAcct', text: 'Claims Listing by Agent/Account', icon: 'mdi-file-chart', route: true },
                  { name: 'osClaimsRIBordereaux', text: 'O/S Claims RI Bordereaux', icon: 'mdi-file-chart', route: true },
                  { name: 'userApprovalList', text: 'User Approval List', icon: 'mdi-file-chart', route: true }
                ]
              },
              {
                name: 'reportAcct',
                text: 'Accounts Reports',
                children: [
                  { name: 'acctTransaction', text: 'Accounts Transactions', icon: 'mdi-file-chart', route: true },
                  { name: 'agedDebtorsAnalysis', text: 'Aged Debtors Analysis', icon: 'mdi-file-chart', route: true },
                  {
                    name: 'bankAccount',
                    text: 'Bank Accounts',
                    icon: 'mdi-file-chart',
                    route: true,
                    children: [
                      { name: 'cashListDebtor', text: 'Cash List for Debtor Accounts', hidden: true, route: true },
                      { name: 'bankBalance', text: 'Daily / Monthly Bank Balance', hidden: true, route: true },
                      { name: 'cashBook', text: 'Daily / Monthly Cash Book', hidden: true, route: true }
                    ]
                  },
                  { name: 'clmIOTaxReport', text: 'Claims Input & Output Tax', icon: 'mdi-file-chart', route: true },
                  { name: 'inProgress(36)', text: 'Financial Statements', route: true },
                  { name: 'glPostChecklist', text: 'GL Posting Checklist', icon: 'mdi-file-chart', route: true },
                  { name: 'glReport', text: 'GL Reports', icon: 'mdi-file-chart', route: true },
                  { name: 'grossRiCeStat', text: 'Gross & RI Ceded Statistics', icon: 'mdi-file-chart', route: true },
                  { name: 'gstReport', text: 'GST Reports', icon: 'mdi-file-chart', route: true },
                  { name: 'matchedAcctTrans', text: 'Matched Accounts Transactions', icon: 'mdi-file-chart', route: true },
                  { name: 'unMatchedAcctTrans', text: 'Unmatched Accounts Transactions', icon: 'mdi-file-chart', route: true },
                  { name: 'volCessions', text: 'Voluntary Cessions', icon: 'mdi-file-chart', route: true },
                  { name: 'CSpremAnalysis2', text: 'CS Premium Analysis 2', icon: 'mdi-file-chart', route: true }
                ]
              },
              {
                name: 'reportTty',
                text: 'Treaty Reports',
                children: [
                  { name: 'outwardsTreatyPremium', text: 'Outwards Treaty Premium & Commission', icon: 'mdi-file-chart', route: true },
                  { name: 'ttyAcctClosing', text: 'Treaty Accounting Closing', icon: 'mdi-file-chart', route: true },
                  { name: 'ttyOsClm', text: 'Treaty Outstanding Claims', icon: 'mdi-file-chart', route: true },
                  { name: 'inProgress(767)', text: 'Treaty RI Aging', route: true },
                  { name: 'ttyStmtAuditListB', text: 'Treaty Statement Audit List B', icon: 'mdi-file-chart', route: true }
                ]
              },
              // reserved for placing customisation not deemed as standard -is
              {
                name: 'reportCust',
                text: 'Custom Reports 1',
                children: [
                  { name: 'inProgress(708)', text: 'Claims RI Recovery', route: true },
                  { name: 'codeOfPractice', text: 'Code of Practice', icon: 'mdi-file-chart', route: true },
                  { name: 'inProgress(743)', text: 'Coinsurance Fee Details', route: true },
                  { name: 'crossSelling', text: 'Cross Selling', icon: 'mdi-file-chart', route: true },
                  { name: 'glList', text: 'GL List', icon: 'mdi-file-chart', route: true },
                  { name: 'glStat', text: 'GL Stat', icon: 'mdi-file-chart', route: true },
                  { name: 'newRenewalPolicy', text: 'New & Renewal Policy', icon: 'mdi-file-chart', route: true },
                  { name: 'inProgress(728)', text: 'Renewal Policy Status', route: true },
                  { name: 'riBusStat', text: 'RI Business Statistics', icon: 'mdi-file-chart', route: true },
                  { name: 'soaSupplement', text: 'SOA Supplement', icon: 'mdi-file-chart', route: true },
                  { name: 'inProgress(740)', text: 'Takaful Statistics', route: true },
                  { name: 'uobInstructionSlip', text: 'UOB Instruction Slip', icon: 'mdi-file-chart', route: true },
                  { name: 'uprList', text: 'UPR List', icon: 'mdi-file-chart', route: true },
                  { name: 'directorRelationship', text: 'Directors Relationship Report', icon: 'mdi-file-chart', route: true },
                  { name: 'polReviewRelUsr', text: 'Policy Reviewed and Released by Same User', icon: 'mdi-file-chart', route: true },
                  { name: 'claimWithLate', text: 'Claims With No/Late Acknowledgement/Request Date', icon: 'mdi-file-chart', route: true },
                  { name: 'surplusTreatyMasterListFormat', text: 'Surplus Treaty MasterList Format 2', icon: 'mdi-file-chart', route: true }
                  // { name: 'masInsExp', text: 'MAS Insurance Exposure', icon: 'mdi-file-chart', route: true }
                ]
              }
              // remove comments when doing custom reports 2 -is
              /* {
                name: 'reportCust2',
                text: 'Custom Reports 2',
                children: [
                  { name: 'inProgress(723)', text: 'Form G1 (Form 6)', route: true }
                ]
              } */
            ]
          },
          {
            name: 'parameter',
            text: 'Parameters',
            icon: 'mdi-tune',
            children: [
              {
                name: 'wizard',
                text: 'Wizards',
                children: [
                  { name: 'inProgress(100)', text: 'Setting up a new Product Rating', route: true },
                  { name: 'inProgress(101)', text: 'Maintaining a Voyage Master file', route: true },
                  { name: 'inProgress(102)', text: 'Setup a new Intermediary', route: true },
                  { name: 'inProgress(103)', text: 'Add a new Workshop on your panel', route: true },
                  { name: 'inProgress(104)', text: 'How do you want to make Payments for Claims', route: true },
                  { name: 'inProgress(105)', text: 'Setup your new Treaty Programme', route: true }
                ]
              },
              {
                name: 'paramGlobal',
                text: 'Global Parameters',
                children: [
                  {
                    name: 'busClsList',
                    text: 'Business Class',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'busClsReview', text: 'Business Class', hidden: true, route: true },
                      { name: 'busClsQuery', text: 'Business Class', hidden: true, route: true },
                      {
                        name: 'pmtBenefitPerBusClsList',
                        text: 'Permitted Benefit per Business Class',
                        icon: 'mdi-tune',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'pmtBenefitPerBusClsReview', text: 'Permitted Benefit per Business Class', hidden: true, route: true }
                        ]
                      },
                      {
                        name: 'giaClsGrp',
                        text: 'GIA Class Group',
                        icon: 'mdi-tune',
                        hidden: true,
                        route: true
                      },
                      {
                        name: 'ifrsClsGrp',
                        text: 'IFRS Class Group',
                        icon: 'mdi-tune',
                        hidden: true,
                        route: true
                      },
                      {
                        name: 'portfolio',
                        text: 'Portfolio',
                        icon: 'mdi-tune',
                        hidden: true,
                        route: true
                      },
                      {
                        name: 'subPortfolio',
                        text: 'Sub-Portfolio',
                        icon: 'mdi-tune',
                        hidden: true,
                        route: true
                      },
                      { name: 'busClsGroup', text: 'Business Class Group', route: true },
                      { name: 'inProgress(40)', text: 'Permitted Clause per Business Class', hidden: true, route: true },
                      { name: 'busClsCvr', text: 'Permitted Cover Type per Business Class', hidden: true, route: true },
                      { name: 'pmtStdRiskTxtPerBusCls', text: 'Permitted Standard Risk Text per Business Class', hidden: true, route: true },
                      { name: 'inProgress(41)', text: 'Permitted Statistic Type per Business Class', hidden: true, route: true },
                      { name: 'pmtTariffPerBusCls', text: 'Permitted Tariff per Business Class', hidden: true, route: true },
                      { name: 'pmtTariffPerBusClsReview', text: 'Permitted Tariff per Business Class', hidden: true, route: true },
                      { name: 'busClsUom', text: 'Permitted UOM per Business Class', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'clause',
                    text: 'Clause',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'reviewClause', text: 'Clause', hidden: true, route: true },
                      { name: 'polTypeClauseMenu', text: 'Permitted Clause per Policy Type', hidden: true, route: true },
                      { name: 'busClsClauseMenu', text: 'Permitted Clause per Business Class', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'companyInfoReview',
                    text: 'Company',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      {
                        name: 'branchList',
                        text: 'Branch',
                        route: true,
                        children: [
                          { name: 'branchReview', text: 'Branch', hidden: true, route: true },
                          { name: 'branchDriReview', text: 'Branch & Direct / RI Inwards Parameters', hidden: true, route: true }
                        ]
                      },
                      { name: 'dept', text: 'Department', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'ctyList',
                    text: 'Country',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'countryDet', text: 'Country', hidden: true, route: true },
                      { name: 'ctyZoneList', text: 'Permitted Zone per Country', hidden: true, route: true },
                      {
                        name: 'regionList',
                        text: 'Region',
                        route: true,
                        children: [
                          { name: 'regionDet', text: 'Region', hidden: true, route: true }
                        ]
                      }
                    ]
                  },
                  {
                    name: 'cover',
                    text: 'Cover Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'coverReviewBusClsCvr', text: 'Permitted Cover Type per Business Class', hidden: true, route: true }
                    ]
                  },
                  { name: 'currency', text: 'Currency', icon: 'mdi-tune', route: true },
                  {
                    name: 'defText',
                    text: 'Default Text',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'defTextReview', text: 'Default Text', hidden: true, route: true },
                      { name: 'polTypeDefTxt', text: 'Permitted Default Text per Policy Type', hidden: true, route: true },
                      { name: 'busClsDefTxt', text: 'Permitted Default Text per Business Class', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'docHdgTxtList',
                    text: 'Document Heading',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'docHdgTxtReview', text: 'Document Heading Text', hidden: true, route: true }
                    ]
                  },
                  { name: 'docNoForm', text: 'Document No. Format', icon: 'mdi-tune', route: true },
                  {
                    name: 'global',
                    text: 'Miscellaneous Parameters',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'miscAcct', text: 'Miscellaneous Accounts Parameters', route: true },
                      { name: 'miscClm', text: 'Miscellaneous Claims Parameters', route: true },
                      { name: 'miscTty', text: 'Miscellaneous Treaty Parameters', route: true }
                    ]
                  },
                  {
                    name: 'paytMethList',
                    text: 'Payment Method',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'paytMethReview', text: 'Payment Method', hidden: true, route: true },
                      { name: 'paytMethQuery', text: 'Payment Method', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'polTypeList',
                    text: 'Policy Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'polTypeDet', text: 'Policy Type', hidden: true, route: true },
                      { name: 'polTypeCls', text: 'Permitted Business Class per Policy Type', hidden: true, route: true },
                      { name: 'polTypeBusCls', text: 'Permitted Business Class per Policy Type', hidden: true, route: true },
                      { name: 'polTypeClause', text: 'Permitted Clause per Policy Type', hidden: true, route: true },
                      { name: 'polTypeStatsType', text: 'Permitted Statistic Type per Policy Type', hidden: true, route: true },
                      { name: 'polTypeGrp', text: 'Policy Type Group', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'procNotif',
                    text: 'Process Notification Settings',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'procNotifReview', text: 'Process Notification Settings', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'stdRiskTxtList',
                    text: 'Standard Risk Text',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'stdRiskTxtReview', text: 'Standard Risk Text', hidden: true, route: true },
                      { name: 'stdItemTxtList', text: 'Standard Item Text', hidden: true, route: true },
                      { name: 'stdItemTxtReview', text: 'Standard Item Text', hidden: true, route: true },
                      {
                        name: 'stdItemTxtDefBen',
                        text: 'Standard Item Text Default Benefit',
                        route: true,
                        children: [
                          { name: 'stdItemTxtDefBenReview', text: 'Standard Item Text Default Benefit', hidden: true, route: true }
                        ]
                      },
                      {
                        name: 'defStdRiskTxt',
                        text: 'Default Standard Risk Text',
                        route: true,
                        children: [
                          { name: 'defStdRiskTxtDet', text: 'Default Standard Risk Text', hidden: true, route: true }
                        ]
                      }
                    ]
                  },
                  { name: 'statsTypeVal', text: 'Statistic Type', icon: 'mdi-tune', route: true },
                  { name: 'docNoSeq', text: 'Various Sequence No.', icon: 'mdi-tune', route: true }
                ]
              },
              {
                name: 'paramUW',
                text: 'Underwriting Parameters',
                children: [
                  { name: 'benList', text: 'Benefit', icon: 'mdi-tune', route: true },
                  {
                    name: 'boIncenSchParam',
                    text: 'Bonus Incentive Scheme',
                    route: true,
                    icon: 'mdi-tune',
                    children: [
                      { name: 'bonusPtsReview', text: 'Bonus Incentive Scheme', hidden: true, route: true },
                      { name: 'sector', text: 'Sector', hidden: true, route: true },
                      {
                        name: 'division',
                        text: 'Division',
                        route: true,
                        children: [
                          { name: 'divisionReview', text: 'Division', hidden: true, route: true }
                        ]
                      },
                      {
                        name: 'team',
                        text: 'Team',
                        route: true,
                        children: [
                          { name: 'teamReview', text: 'Team', hidden: true, route: true }
                        ]
                      },
                      { name: 'arm',
                        text: 'ARM',
                        route: true,
                        children: [
                          { name: 'armReview', text: 'ARM', hidden: true, route: true }
                        ]
                      }
                    ]
                  },
                  { name: 'busSrc', text: 'Business Source', icon: 'mdi-tune', route: true },
                  {
                    name: 'campaignList',
                    text: 'Campaign',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'campaignReview', text: 'Campaign', hidden: true, route: true },
                      {
                        name: 'campaignCommList',
                        text: 'Campaign Commission',
                        route: true,
                        children: [
                          { name: 'campaignCommReview', text: 'Campaign Commission', hidden: true, route: true }
                        ]
                      },
                      {
                        name: 'campaignDiscList',
                        text: 'Campaign Discount',
                        route: true,
                        children: [
                          { name: 'campaignDiscReview', text: 'Campaign Discount', hidden: true, route: true }
                        ]
                      },
                      {
                        name: 'campaignPromotionList',
                        text: 'Campaign Promotion',
                        route: true,
                        children: [
                          { name: 'campaignPromotionReview', text: 'Campaign Promotion', hidden: true, route: true }
                        ]
                      },
                      {
                        name: 'promotionList',
                        text: 'Promotion',
                        route: true,
                        children: [
                          { name: 'promotionReview', text: 'Promotion', hidden: true, route: true },
                          {
                            name: 'promotionFactorList',
                            text: 'Promotion Factor',
                            route: true,
                            children: [
                              { name: 'promotionFactorReview', text: 'Promotion Factor', hidden: true, route: true },
                              {
                                name: 'promotionRateList',
                                text: 'Promotion Rate',
                                route: true,
                                children: [
                                  { name: 'promotionRateReview', text: 'Promotion Rate', hidden: true, route: true }
                                ]
                              }
                            ]
                          },
                          {
                            name: 'promotionCardList',
                            text: 'Promotion Card',
                            route: true,
                            children: [
                              { name: 'promotionCardReview', text: 'Promotion Card', hidden: true, route: true },
                              {
                                name: 'promotionCardCodeList',
                                text: 'Promotion Card Code',
                                route: true,
                                children: [
                                  { name: 'promotionCardCodeReview', text: 'Promotion Card Code', hidden: true, route: true }
                                ]
                              },
                              {
                                name: 'promotionCardNumberList',
                                text: 'Promotion Card No.',
                                route: true,
                                children: [
                                  { name: 'promotionCardNumberReview', text: 'Promotion Card No.', hidden: true, route: true }
                                ]
                              }
                            ]
                          },
                          {
                            name: 'promotionCouponList',
                            text: 'Promotion Coupon',
                            route: true,
                            children: [
                              { name: 'promotionCouponReview', text: 'Promotion Coupon', hidden: true, route: true }
                            ]
                          },
                          {
                            name: 'promotionUserGroupList',
                            text: 'Promotion User Group',
                            route: true,
                            children: [
                              { name: 'promotionUserGroupReview', text: 'Promotion User Group', hidden: true, route: true },
                              {
                                name: 'promotionMemberGroupList',
                                text: 'Promotion Member Group',
                                route: true,
                                children: [
                                  { name: 'promotionMemberGroupReview', text: 'Promotion Member Group', hidden: true, route: true }
                                ]
                              },
                              {
                                name: 'promotionLoyaltyList',
                                text: 'Promotion Loyalty',
                                route: true,
                                children: [
                                  { name: 'promotionLoyaltyReview', text: 'Promotion Loyalty', hidden: true, route: true }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        name: 'campaignIntermediaryList',
                        text: 'Permitted Intermediary per Campaign',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'campaignIntermediaryReview', text: 'Permitted Intermediary per Campaign', hidden: true, route: true }
                        ]
                      }
                    ]
                  },
                  {
                    name: 'coverLetter',
                    text: 'Cover Letter',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      {
                        name: 'paytStatLtr',
                        text: 'Payment Status Letter',
                        icon: 'mdi-tune',
                        route: true,
                        children: [
                          { name: 'paytStatLtrDetail', text: 'Payment Status Letter', hidden: true, route: true }
                        ]
                      },
                      { name: 'cancelLtr', text: 'Cancellation Letter', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'custLogType',
                    text: 'Customer Log Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'custLogTypeReview', text: 'Customer Log Type', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'discLdgList',
                    text: 'Discount / Loading Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'discLdgReview', text: 'Discount / Loading Type', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'endtCode',
                    text: 'Endorsement Code',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'cancelCode', text: 'Cancellation Code', route: true },
                      { name: 'giroBank', text: 'GIRO BIC', route: true }
                    ]
                  },
                  {
                    name: 'fireDistCls',
                    text: 'Fire District Class',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'fireConstrnCls', text: 'Fire Construction Class', route: true },
                      { name: 'fireOccpncy', text: 'Fire Occupancy', route: true },
                      { name: 'fireOccpnCls', text: 'Fire Occupation Class', route: true },
                      { name: 'fireOccpnClsLim', text: 'Fire Occupation Class Limit', route: true }
                    ]
                  },
                  { name: 'industryGrp',
                    text: 'Industry Group',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'occupation', text: 'Occupation', route: true },
                      { name: 'relationship', text: 'Relationship', route: true },
                      { name: 'termReason', text: 'Termination Reason', route: true },
                      { name: 'injuredPersonType', text: 'Injured Person Type', route: true }
                    ]
                  },
                  {
                    name: 'marineCargoComdty',
                    text: 'Marine Cargo Commodity',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'marineCargoConveyance', text: 'Marine Cargo Conveyance Type', route: true },
                      { name: 'marineCargoPack', text: 'Marine Cargo Packing Type', route: true },
                      { name: 'marineCargoPort', text: 'Marine Cargo Port', route: true },
                      { name: 'marineCargoVoyage', text: 'Marine Cargo Voyage Area', route: true },
                      { name: 'marineCargoVoyageDate', text: 'Marine Cargo Voyage Date', route: true }
                    ]
                  },
                  {
                    name: 'vslDet',
                    text: 'Marine Vessel Master',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'vslDetReview',
                        text: 'Marine Vessel Master',
                        route: true,
                        children: [
                          { name: 'vslVoyReview', text: 'Marine Voyage Master', hidden: true, route: true }
                        ]
                      },
                      { name: 'vslCls', text: 'Marine Vessel Class', route: true },
                      { name: 'vslConstn', text: 'Marine Vessel Construction', route: true },
                      { name: 'vslEngMake', text: 'Marine Vessel Engine Make', route: true },
                      { name: 'vslEngMod', text: 'Marine Vessel Engine Model', route: true },
                      { name: 'vslFlag', text: 'Marine Vessel Flag', route: true },
                      { name: 'vslType', text: 'Marine Vessel Type', route: true }
                    ]
                  },
                  {
                    name: 'mtrVehGrp',
                    text: 'Motor Vehicle Group',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      {
                        name: 'ltaParam',
                        text: 'Motor LTA Parameters',
                        route: true,
                        children: [
                          { name: 'ltaParamReview', text: 'Motor LTA Parameters', hidden: true, route: true }
                        ]
                      },
                      { name: 'mtrNCD', text: 'Motor NCD Rate', route: true },
                      { name: 'mtrStandardTxt', text: 'Motor Standard Text', route: true },
                      { name: 'mtrVehMake', text: 'Motor Vehicle Make', route: true },
                      {
                        name: 'mtrVehModel',
                        text: 'Motor Vehicle Model',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'mtrVehModelReview', text: 'Motor Vehicle Model', hidden: true, route: true }
                        ]
                      },
                      { name: 'mtrVehType', text: 'Motor Vehicle Type', route: true },
                      { name: 'mtrVehUsg', text: 'Motor Vehicle Usage', route: true }
                    ]
                  },
                  {
                    name: 'polStat',
                    text: 'Policy Status',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'polStatDet', text: 'Policy Status', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'riskProfiles',
                    text: 'Risk Profile',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'riskProfReview', text: 'Risk Profile', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'scheme',
                    text: 'Scheme',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'schemeClause', text: 'Default Scheme Clause', hidden: true, route: true },
                      { name: 'duration', text: 'Duration', route: true },
                      { name: 'dmncbParam', text: 'No Claim Bonus', route: true },
                      { name: 'pkgPlan',
                        text: 'Package Plan',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'pkgPlanReview', text: 'Package Plan', hidden: true, route: true },
                          { name: 'arbList',
                            text: 'Annual Renewal Bonus',
                            hidden: true,
                            route: true,
                            children: [
                              { name: 'arbReview', text: 'Annual Renewal Bonus', hidden: true, route: true }
                            ] },
                          { name: 'insdAgeBandList',
                            text: 'Insured Age Band',
                            hidden: true,
                            route: true,
                            children: [
                              { name: 'insdAgeBandReview', text: 'Insured Age Band', hidden: true, route: true }
                            ] },
                          {
                            name: 'pkgRiskList',
                            text: 'Package Risk',
                            hidden: true,
                            route: true,
                            children: [
                              { name: 'pkgRiskReview', text: 'Package Risk', hidden: true, route: true },
                              {
                                name: 'pkgRiskItemList',
                                text: 'Package Item',
                                hidden: true,
                                route: true,
                                children: [
                                  { name: 'pkgRiskItemReview',
                                    text: 'Package Item',
                                    hidden: true,
                                    route: true,
                                    children: [
                                      { name: 'pkgSubItemList',
                                        text: 'Package Sub Item',
                                        hidden: true,
                                        route: true,
                                        children: [
                                          { name: 'pkgSubItemReview', text: 'Sub Item Details', hidden: true, route: true }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      { name: 'pckgTariffBen',
                        text: 'Package Tariff Benefit',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'pckgTariffBenDetail', text: 'Package Tariff Benefit', hidden: true, route: true }
                        ]
                      },
                      { name: 'pckgTariffFact',
                        text: 'Package Tariff Factor',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'pckgTariffFactDetail',
                            text: 'Package Tariff Factor',
                            hidden: true,
                            route: true,
                            children: [
                              { name: 'pckgTariffRate',
                                text: 'Package Tariff Rate',
                                hidden: true,
                                route: true,
                                children: [
                                  { name: 'pckgTariffRateDetail', text: 'Package Tariff Rate', hidden: true, route: true }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      { name: 'pkgStdRiskTxt',
                        text: 'Package Standard Risk Text',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'pkgStdRiskTxtReview',
                            text: 'Package Standard Risk Text',
                            hidden: true,
                            route: true,
                            children: [
                              { name: 'pkgStdItemTxt',
                                text: 'Package Standard Item Text',
                                hidden: true,
                                route: true,
                                children: [
                                  { name: 'pkgStdItemTxtReview',
                                    text: 'Package Standard Item Text',
                                    hidden: true,
                                    route: true,
                                    children: [
                                      { name: 'pkgStdSubItemTxt',
                                        text: 'Package Standard Sub-Item Text',
                                        hidden: true,
                                        route: true,
                                        children: [
                                          { name: 'pkgStdSubItemTxtReview', text: 'Package Standard Sub-Item Text', hidden: true, route: true }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      { name: 'schemeDuration', text: 'Scheme Duration', route: true },
                      { name: 'schemeReview', text: 'Scheme', hidden: true, route: true },
                      { name: 'schemeReviewPolTypeScheme', text: 'Permitted Scheme per Policy Type', hidden: true, route: true },
                      {
                        name: 'polTypeScheme',
                        text: 'Scheme & Policy Type Parameters',
                        route: true,
                        children: [
                          { name: 'polTypeSchemeReview', text: 'Permitted Scheme per Policy Type', hidden: true, route: true }
                        ]
                      }
                    ]
                  },
                  { name: 'shrtTrmRate',
                    text: 'Short Term Rate',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'shrtTrmRateDetail', text: 'Short Term Rate', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'tariffCode',
                    text: 'Tariff',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'riskFactor',
                        text: 'Risk Factor',
                        route: true,
                        children: [
                          { name: 'riskFactorDetail', text: 'Risk Factor', hidden: true, route: true }
                        ]
                      },
                      {
                        name: 'tarfBenList',
                        text: 'Tariff Benefit',
                        route: true,
                        children: [
                          { name: 'tarfBenReview', text: 'Tariff Benefit', hidden: true, route: true }
                        ]
                      },
                      { name: 'tarfFactor',
                        text: 'Tariff Factor',
                        route: true,
                        children: [
                          { name: 'tarfFactDetail',
                            text: 'Tariff Factor',
                            hidden: true,
                            route: true,
                            children: [
                              { name: 'tarfRate',
                                text: 'Tariff Rate',
                                hidden: true,
                                route: true,
                                children: [
                                  { name: 'tarfRateDetail', text: 'Tariff Rate', hidden: true, route: true }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      { name: 'tarfPrem',
                        text: 'Tariff Premium',
                        route: true,
                        children: [
                          { name: 'tarfPremDetail', text: 'Tariff Premium', hidden: true, route: true }
                        ]
                      }
                    ]
                  },
                  { name: 'uom', text: 'Unit of Measure', icon: 'mdi-tune', route: true },
                  {
                    name: 'propPlan',
                    text: 'UOB Proposal Plan',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'propPlanReview', text: 'UOB Proposal Plan', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'propStat',
                    text: 'UOB Proposal Status',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'propStatReview', text: 'UOB Proposal Status', hidden: true, route: true }
                    ]
                  }
                ]
              },
              {
                name: 'paramRI',
                text: 'Reinsurance Parameters',
                children: [
                  {
                    name: 'accumTypeList',
                    text: 'Accumulation Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'accumTypeReview', text: 'Accumulation Type', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'blkGrp',
                    text: 'Block Group',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'blkSubGrp1', text: 'Block Sub Group 1', hidden: true, route: true },
                      { name: 'blkSubGrp2', text: 'Block Sub Group 2', hidden: true, route: true },
                      {
                        name: 'blk',
                        text: 'Block',
                        route: true,
                        children: [
                          { name: 'blkReview', text: 'Block', hidden: true, route: true }
                        ]
                      },
                      {
                        name: 'blkTtyLim',
                        text: 'Block Treaty Limit',
                        route: true,
                        children: [
                          { name: 'blkTtyLimReview', text: 'Block Treaty Limit', hidden: true, route: true }
                        ]
                      }
                    ]
                  },
                  {
                    name: 'coRIPanelList',
                    text: 'CO / RI Panel',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'coRIPanelReview', text: 'CO / RI Panel', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'rtnLimList',
                    text: 'Retention Limit',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'rtnLimDet', text: 'Retention Limit', hidden: true, route: true }
                    ]
                  },
                  { name: 'treatyLimit',
                    text: 'Treaty Limit',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'treatyLimitDetail', text: 'Treaty Limit', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'treatyParamsList',
                    text: 'Treaty Parameters',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'treatyParamsReview', text: 'Treaty Parameters', hidden: true, route: true },
                      {
                        name: 'treatyDetail',
                        text: 'Treaty Details',
                        icon: 'mdi-tune',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'miscTreatyInfo1', text: 'Treaty Information 1', hidden: true, route: true },
                          { name: 'miscTreatyInfo2', text: 'Treaty Information 2', hidden: true, route: true },
                          { name: 'treatyRI2', text: 'Treaty Reinsurer', hidden: true, route: true }
                        ]
                      },
                      { name: 'treatyPeriod', text: 'Treaty Period', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'volCesLimList',
                    text: 'Voluntary Cession Limit',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'volCesLimDet', text: 'Voluntary Cession Limit', hidden: true, route: true }
                    ]
                  }
                ]
              },
              {
                name: 'paramClm',
                text: 'Claims Parameters',
                children: [
                  { name: 'eventType', text: 'Claims Event Type', icon: 'mdi-tune', route: true },
                  {
                    name: 'usrClmLim',
                    text: 'Claims Limit per User',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'usrClmLimReview', text: 'Claims Limit per User', route: true, hidden: true }
                    ]
                  },
                  {
                    name: 'clmNOL1List',
                    text: 'Claims Nature of Loss',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      {
                        name: 'pmtNOL1PerBusClsList',
                        text: 'Permitted Claims NOL per Business Class',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'pmtNOL1PerBusClsReview', text: 'Permitted Claims NOL per Business Class', hidden: true, route: true }
                        ]
                      },
                      { name: 'clmNOL1Review', text: 'Claims Nature of Loss 1', hidden: true, route: true },
                      { name: 'clmNOL2List', text: 'Claims Nature of Loss 2', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'clmPaytTypeList',
                    text: 'Claims Payment Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'clmPaytTypeReview', text: 'Claims Payment Type', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'clmResCatList',
                    text: 'Claims Reserve Category',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'clmResCatReview', text: 'Claims Reserve Category', hidden: true, route: true },
                      {
                        name: 'pmtClmResCatPerBusClsList',
                        text: 'Permitted Reserve Category per Business Class',
                        hidden: true,
                        route: true,
                        children: [
                          { name: 'pmtClmResCatPerBusClsReview', text: 'Permitted Reserve Category per Business Class', hidden: true, route: true }
                        ]
                      }
                    ]
                  },
                  {
                    name: 'clmStat',
                    text: 'Claims Status',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'clmStatReview', text: 'Claims Status', hidden: true, route: true },
                      { name: 'clmStatCause', text: 'Cause of Claims Status', hidden: true, route: true }
                    ]
                  }
                ]
              },
              {
                name: 'paramAcct',
                text: 'Accounts Parameters',
                children: [
                  {
                    name: 'acctNoSfx',
                    text: 'Account No. Suffix',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'acctNoSfxDet', text: 'Account No. Suffix', hidden: true, route: true }
                    ]
                  },
                  { name: 'acctPeriod',
                    text: 'Accounting Period',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'acctPeriodDet', text: 'Accounting Period', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'bankAcctList',
                    text: 'Bank Account',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'bankAcctDet', text: 'Bank Account', hidden: true, route: true },
                      { name: 'bankAbbrev', text: 'Abbreviated Bank Name', hidden: true, route: true }
                    ]
                  },
                  { name: 'fund', text: 'Fund', icon: 'mdi-tune', route: true },
                  {
                    name: 'glAcctNoList',
                    text: 'GL Account',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      {
                        name: 'glDebtCtrl',
                        text: 'GL Account No. Interface for Debtors Control',
                        icon: 'mdi-tune',
                        route: true,
                        children: [
                          { name: 'glDebtCtrlDet', text: 'GL Account No. Interface for Debtors Control', hidden: true, route: true }
                        ]
                      },
                      { name: 'glMapping', text: 'GL Account No. Interface for Premium & Claims', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'glAnCode',
                    text: 'GL Analysis Code',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'glAnCodeNew', text: 'GL Analysis Code', hidden: true, route: true },
                      { name: 'glAnCodeDet', text: 'GL Analysis Code', hidden: true, route: true }
                    ]
                  },
                  { name: 'glDept', text: 'GL Department', icon: 'mdi-tune', route: true },
                  {
                    name: 'gstKeyCode',
                    text: 'GST Key',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'gstKeyBrn', text: 'GST Key for Branch', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'gstMap',
                    text: 'GST Mapping & Interface',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'gstMapReviewDet', text: 'GST Mapping', hidden: true, route: true },
                      { name: 'gstIntReview', text: 'GST Interface', hidden: true, route: true },
                      { name: 'gstMapQueryDet', text: 'GST Mapping', hidden: true, route: true },
                      { name: 'gstIntQuery', text: 'GST Interface', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'gstStat',
                    text: 'GST Status',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'gstStatDet', text: 'GST Status', hidden: true, route: true }
                    ]
                  },
                  { name: 'tranDateRange', text: 'Transaction Date Range', icon: 'mdi-tune', route: true }
                ]
              },
              {
                name: 'paramTty',
                text: 'Treaty Parameters',
                children: [
                  { name: 'busAnGL', text: 'Business Analysis GL Code', icon: 'mdi-tune', route: true },
                  { name: 'busAn', text: 'Business Analysis Code', icon: 'mdi-tune', route: true },
                  {
                    name: 'calcRate',
                    text: 'Calculation Rate',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'calcRateDet', text: 'Calculation Rate', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'lnCalc',
                    text: 'Line Calculation',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'lnCalcDet', text: 'Line Calculation', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'stmtTypeLnCalc',
                    text: 'Line Calculation by Statement Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'stmtTypeLnCalcDet', text: 'Line Calculation by Statement Type', hidden: true, route: true }
                    ]
                  },
                  { name: 'mainBusCls', text: 'Main Business Class', icon: 'mdi-tune', route: true },
                  {
                    name: 'rtnType',
                    text: 'Retention Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'rtnTypeDet', text: 'Retention Type', hidden: true, route: true }
                    ]
                  },
                  { name: 'riskAreaGL', text: 'Risk Area GL Code', icon: 'mdi-tune', route: true },
                  { name: 'riskArea', text: 'Risk Area', icon: 'mdi-tune', route: true },
                  {
                    name: 'stmtType',
                    text: 'Statement Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'stmtTypeDet', text: 'Statement Type', hidden: true, route: true }
                    ]
                  },
                  { name: 'stmtLnGL', text: 'Statement Line GL Code', icon: 'mdi-tune', route: true },
                  {
                    name: 'stmtLnType',
                    text: 'Statement Line Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'stmtLnTypeDet', text: 'Statement Line Type', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'stmtTypeStmtLnType',
                    text: 'Statement Line Type by Statement Type',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'stmtTypeStmtLnTypeDet', text: 'Statement Line Type by Statement Type', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'treatyDetails',
                    text: 'Treaty Details',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'treatyDetailsReview', text: 'Treaty Details', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'treatyRIList',
                    text: 'Treaty Reinsurance',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'treatyRI', text: 'Treaty Reinsurance', hidden: true, route: true }
                    ]
                  },
                  {
                    name: 'glInterface2List',
                    text: 'GL Interface',
                    icon: 'mdi-tune',
                    route: true,
                    children: [
                      { name: 'GLInterface2Det', text: 'Treaty Reinsurance', hidden: true, route: true }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        name: 'treaty',
        text: 'Treaty',
        children: [
          {
            name: 'treatyAcct',
            text: 'Treaty Accounting',
            icon: 'mdi-google-circles-extended',
            children: [
              {
                name: 'mngTreatyList',
                text: 'Manage Treaties',
                icon: 'mdi-apps',
                route: true,
                children: [
                  { name: 'treatyHeader', text: 'Treaty Statement', icon: 'mdi-apps', route: true }
                ]
              },
              {
                name: 'specFuncTtyAcct',
                text: 'Special Functions',
                children: [
                  { name: 'uploadTtyPremComm', text: 'Upload Treaty Premium & Commission', icon: 'mdi-apps', route: true },
                  { name: 'uploadTtyClmPaymRes', text: 'Upload Treaty Claims Payment & Reserve', icon: 'mdi-apps', route: true },
                  { name: 'genQrtlyStmt', text: 'Generate Quarterly Statements', icon: 'mdi-apps', route: true },
                  { name: 'batchRelMthlyTtyStmt', text: 'Batch Release Monthly Treaty Statement', icon: 'mdi-apps', route: true },
                  { name: 'batchRelQrtlyTtyStmt', text: 'Batch Release Quarterly Treaty Statement', icon: 'mdi-apps', route: true },
                  { name: 'inProgress(43)', text: 'Process 1/24 Method Premium Reserve Retained', route: true },
                  { name: 'inProgress(44)', text: 'Process 1/24 Method Premium Reserve Released', route: true },
                  { name: 'inProgress(45)', text: 'Release Monthly Treaty Statements', route: true },
                  { name: 'inProgress(46)', text: 'Release Quarterly Treaty Statements', route: true },
                  { name: 'inProgress(47)', text: 'Delete Unreleased Treaty Statements', route: true }
                ]
              }
              // {
              //   name: 'documentTty',
              //   text: 'Documents',
              //   children: [
              //     { name: 'inProgress(48)', text: 'Treaty Preliminary Loss Advice', route: true },
              //     { name: 'inProgress(49)', text: 'Treaty Revised Loss Advice', route: true },
              //     { name: 'inProgress(50)', text: 'Treaty Settled Claims Advice', route: true },
              //     { name: 'inProgress(51)', text: 'Treaty Debit / Credit Note', route: true },
              //     { name: 'inProgress(52)', text: 'Treaty Statement of Account', route: true },
              //     { name: 'inProgress(53)', text: 'Treaty Portfolio Transfer Statement', route: true },
              //     { name: 'inProgress(54)', text: 'Treaty Profit Commission Statement', route: true },
              //     { name: 'inProgress(55)', text: 'Treaty Premium Adjustment Statement', route: true },
              //     { name: 'inProgress(56)', text: 'Treaty Minimum & Deposit Premium Statement', route: true }
              //   ]
              // }
            ]
          }
        ]
      },
      {
        name: 'settings',
        text: 'Settings',
        children: [
          {
            name: 'userManagement',
            text: 'User Management',
            icon: 'mdi-folder-account',
            children: [
              {
                name: 'users',
                text: 'Users',
                icon: 'mdi-account-group',
                route: true,
                children: [
                  { name: 'userQuery', text: 'User', hidden: true, route: true },
                  { name: 'userReview', text: 'User', hidden: true, route: true }
                ]
              },
              { name: 'usersSessions', text: 'Sessions', icon: 'mdi-account-network', route: true },
              { name: 'rolesandpermissions', text: 'Roles & Permissions', icon: 'mdi-account-key', route: true },
              {
                name: 'userSecurity',
                text: 'User Security',
                icon: 'mdi-security-account',
                children: [
                  { name: 'userBlock', text: 'Unblock User / IP Address', icon: 'mdi-account-off', route: true },
                  { name: 'whiteList', text: 'Whitelist IP Address', icon: 'mdi-verified', route: true },
                  { name: 'userPassSettings', text: 'User Password Settings', icon: 'mdi-textbox-password', route: true },
                  { name: 'acctSecuritySettings', text: 'Account Security Settings', icon: 'mdi-account-settings-variant', route: true },
                  { name: 'passwordBlacklist', text: 'Password Blacklist', icon: 'mdi-verified', route: true }
                ]
              }
            ]
          },
          { name: 'audLog', text: 'Audit Log', icon: 'mdi-clipboard-text', route: true },
          { name: 'batchJobHistory', text: 'Batch Job History', icon: 'mdi-clock', route: true },
          { name: 'cacheControl', text: 'Cache Control', icon: 'mdi-content-save-settings', route: true },
          { name: 'pubApiTrans', text: 'Public API Transactions', icon: 'mdi-lan-connect', route: true },
          { name: 'rptJobsHistory', text: 'Report Job History', icon: 'mdi-printer', route: true },
          { name: 'unlockRecord', text: 'Unlock Record', icon: 'mdi-lock-open', route: true }
        ]
      },
      {
        name: 'user',
        text: 'User Settings',
        hidden: true,
        route: true,
        children: [
          { name: 'profile', text: 'User Profile', route: true },
          { name: 'changePassword', text: 'Change Password', route: true },
          { name: 'commsSettings', text: 'Communication Settings', route: true }
        ]
      },
      { name: 'notifReports', text: 'Notification - Reports', icon: 'mdi-printer', hidden: true, route: true },
      { name: 'notifMessages', text: 'Notification - Messages', hidden: true, route: true },
      { name: 'notifBatches', text: 'Notification - Batches', hidden: true, route: true }
    ]
  }
]
